import React, { FC } from 'react';

import { EvSkeleton } from '@evinced-private/ui-common';

import '../accessibility_summary/AccessibilitySummary.scss';

export const AccessibilitySummarySkeleton: FC = () => {
	return (
		<div className="accessibility-summary">
			<EvSkeleton height="135px" width="225px" />
			<div className="metric-divider" aria-hidden="true" />
			<div className="metric-group-skeleton">
				<EvSkeleton height="135px" width="200px" />
				<EvSkeleton height="135px" width="200px" />
			</div>
			<div className="metric-divider" aria-hidden="true" />
			<div className="metric-group-skeleton">
				<EvSkeleton height="135px" width="200px" />
				<EvSkeleton height="135px" width="200px" />
			</div>
		</div>
	);
};
